import { ILocationResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const defaultLocationsSort: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];

export type LocationsFilter = Readonly<{
    nameSearch: string;
    corporationId?: string;
    locationId?: string;
    active?: boolean;
}>;

export type LocationsDataSourceOptions = BaseDataSourceOptions<
    ILocationResponse,
    LocationsFilter
>;
export type LocationsPagedDataSource = PagedDataSource<
    ILocationResponse,
    LocationsFilter
>;
export type LocationsInfiniteDataSource = InfiniteDataSource<
    ILocationResponse,
    LocationsFilter
>;

const getAllLocations: DataSourceQuery<ILocationResponse, LocationsFilter> = ({
    filter: { nameSearch, corporationId, locationId, active },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
        locationId ? Filter.eq('Id', locationId) : undefined,
        active ? Filter.eq('Active', active) : undefined,
    );

    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getLocations({ filter, page, pageLimit, orderBy, nameSearch }),
    );
};

export function usePagedLocationsDataSource({
    defaultSort = defaultLocationsSort,
    ...options
}: LocationsDataSourceOptions): LocationsPagedDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAllLocations,
    });
}

export function useInfiniteLocationsDataSource({
    defaultSort = defaultLocationsSort,
    ...options
}: LocationsDataSourceOptions): LocationsInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getAllLocations,
    });
}
